<template>
    <div v-if="buttons.length"
        :class="['bottom-button', {'bottom-button--partner': isPartnerApp, 'bottom-button--embed':isEmbeded}]"
    >
        <router-link v-for="(item, index) in buttons"
            :key="index"
            :class="`button bottom-button__button ${item.class} ${item.disabled ? 'button--disabled' : ''}`"
            :to="item.route"
        >
            {{ item.label }}
        </router-link>
    </div>
</template>

<script>
export default {
    name: 'bottom-button',
    props: {
        buttons: {
            type: Array,
            default: () => [],
            required: true,
        },
        isPartnerApp: {
            type: Boolean,
            default: false,
            required: false,
        },
        isEmbeded: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.bottom-button {
    position: fixed;
    bottom: 6.5rem;
    width: 100%;
    height: 5rem;
    background: $porcelain-color;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 0.2rem solid $mercury-color;
    z-index: 10;

    @include min-width(md) {
        bottom: 0;
        width: calc(100% - 25rem);
    }

    @include min-width(lg) {
        display: none;
    }

    &__button {
        height: 80%;
        width: 90%;
        flex: 1;
        margin: 0.5rem;
    }

    &--partner {
        bottom: 0;
    }

    &--embed {
        @include min-width(md) {
            bottom: 0;
            width: 100%;
        }
    }
}
</style>